import { Children, isValidElement } from 'react';

import mapKeys from 'lodash/mapKeys';

import { CHANGE_RATE, PERCENTEGE } from './Axis';
import { VALUE_TYPE_PERCENT } from './ComposedChart/constants';

export const AnnotationsMetric = () => {
  return null;
};
AnnotationsMetric.displayName = 'annotations-metric';

export const Metric = () => {
  return null;
};

Metric.displayName = 'metric';

export const SubMetric = () => {
  return null;
};

SubMetric.displayName = 'sub-metric';

export const MetricsTooltip = () => {
  return null;
};
MetricsTooltip.defaultProps = {
  labelTemplate: 'EEEE, dd MMM, yyyy',
};
MetricsTooltip.displayName = 'metrics-tooltip';

export const Series = () => {
  return null;
};

Series.defaultProps = {
  dateKey: 'Date',
};
Series.displayName = 'series';

export const DateAxis = () => {
  return null;
};

DateAxis.defaultProps = {
  template: 'D. MMM',
};

DateAxis.displayName = 'date-axis';

export const NoSeriesPlaceholder = () => {
  return null;
};

NoSeriesPlaceholder.displayName = 'init-placeholder';

const getNestedKey = (metricId, parentId) =>
  `${parentId !== undefined ? `${parentId}_` : ''}${metricId}`;

export const parseAnnotationsMetric = (
  { children, dataKey: dataKeyProp, id, ...props },
  { seriesKey }
) => {
  const dataKey = getNestedKey(dataKeyProp, seriesKey);

  return {
    ...props,
    dataKey,
    id,
  };
};

export const parseMetric = (
  { children, dataKey: dataKeyProp, id, ...props },
  { seriesKey, ...parentProps }
) => {
  const dataKey = getNestedKey(dataKeyProp, seriesKey);

  const metric = {
    ...parentProps,
    ...props,
    dataKey,
    id,
  };

  if (metric.type === 'pie') {
    return {
      metric,
      subMetrics: [],
    };
  }
  if (metric.compared) {
    // if (metric.type === 'scatter') {
    //   metric.type = 'line';
    // }
    metric.dashed = true;
  }

  if (metric.stacked) {
    if (metric.type === 'line') {
      metric.type = 'area';
    }
    metric.stackId = metric.mode
      ? `${metric.yAxisGroup}: ${metric.mode}`
      : metric.yAxisGroup;
  }

  if (metric.percentage) {
    metric.yAxisGroup = PERCENTEGE;
  }

  if (metric.mode === 'TREND') {
    metric.type = 'line';
    metric.secondary = true;
  }

  if (metric.mode === 'CHR') {
    metric.yAxisGroup = CHANGE_RATE;
    metric.valueType = VALUE_TYPE_PERCENT;
    metric.dashed = true;
  }

  if (metric.mode === 'CHD') {
    metric.dashed = true;
  }

  return {
    metric,
    subMetrics: children
      ? parseChildren(children, {
          ...metric,
          seriesKey: seriesKey,
        }).metrics
      : [],
  };
};

export const parseSeries = (
  { children, seriesKey, data, dateKey, period, ...props },
  parentProps
) => {
  const { metrics, annotationsMetric } = parseChildren(children, {
    ...parentProps,
    ...props,
    seriesKey,
  });
  return {
    series: {
      dateKey: getNestedKey(dateKey, seriesKey),
      period: period,
      data:
        data &&
        data.map((row) => mapKeys(row, (_, k) => getNestedKey(k, seriesKey))),
    },
    metrics,
    annotationsMetric,
  };
};

export const parseChildren = (children, parentProps = {}) => {
  const metrics = [];
  const series = [];
  const unknown = [];

  let annotationsMetric = null;
  let dateAxis = null;
  let metricsTooltip = null;
  let noSeriesPlaceholder = null;

  children &&
    Children.toArray(children).forEach((child, i) => {
      if (isValidElement(child)) {
        const childProps = {
          id: getNestedKey(i, parentProps.id),
          ...child.props,
        };
        let parsed;
        switch (child.type.displayName) {
          case Series.displayName:
            parsed = parseSeries(childProps, parentProps);

            series.push(parsed.series);
            parsed.metrics.forEach((metric) => metrics.push(metric));
            annotationsMetric = parsed.annotationsMetric || annotationsMetric;
            break;
          case SubMetric.displayName:
          case Metric.displayName:
            parsed = parseMetric(childProps, parentProps);

            metrics.push(parsed.metric);
            parsed.subMetrics.forEach((subMetric) => metrics.push(subMetric));
            break;

          case AnnotationsMetric.displayName:
            annotationsMetric = parseAnnotationsMetric(childProps, parentProps);
            break;
          case DateAxis.displayName:
            dateAxis = childProps;
            break;
          case MetricsTooltip.displayName:
            metricsTooltip = childProps;
            break;
          case NoSeriesPlaceholder.displayName:
            noSeriesPlaceholder = childProps.text;
            break;
          default:
            unknown.push(child);
        }
      }
    });

  return {
    annotationsMetric,
    metrics,
    series,
    unknown,
    dateAxis,
    metricsTooltip,
    noSeriesPlaceholder,
  };
};
